// extracted by mini-css-extract-plugin
module.exports = {"button":"_facaeb4e","disabled":"_fe4bffe8","primaryButton":"_af178582"};